export default __webpack_public_path__ + "static/media/ic_text-align-justify.90dfff6c.svg";